import LoadingAnimation from '@/components/LoadingAnimation/LoadingAnimation'
import { Text } from '@/components'
import { findBrandByPortal } from '@/types/thermostatBrands'
import ConfigureDeviceStepBody from '../components/ConfigureDeviceStepBody'
import ConfigureDeviceCard from '../components/ConfigureDeviceCard'
import ConfigureSettingRow from '../components/ConfigureSettingRow'
import useConfigureThermostatViewModel from './ConfigureThermostat.viewmodel'

export default function ConfigureThermostat() {
  const {
    isLoadingOrIdle,
    thermostat,
    displayName,
    settingPaths,
    gridSupportSummary,
  } = useConfigureThermostatViewModel()

  if (isLoadingOrIdle) {
    return (
      <div className="flex justify-center items-center h-full">
        <LoadingAnimation type="falling" />
      </div>
    )
  }

  const subtitle = thermostat?.portal
    ? `${thermostat.portal} Thermostat`
    : 'Thermostat'
  // Reuse the same portal→deviceImage mapping the device-selection gallery
  // uses (`/img/<brand>.webp`). Fallback to nest if the portal is unknown,
  // matching the existing convention in useSelectionGalleryResources.
  const brandImage =
    (thermostat?.portal && findBrandByPortal(thermostat.portal)?.deviceImage) ??
    '/img/nest.webp'
  const illustration = (
    <img
      src={brandImage}
      alt={subtitle}
      className="h-16 w-auto object-contain"
    />
  )

  return (
    <ConfigureDeviceStepBody>
      <ConfigureDeviceCard
        title={displayName}
        subtitle={subtitle}
        illustration={illustration}
      >
        <ConfigureSettingRow
          iconName="Thermostat"
          title="Event Temperatures"
          description="How far we'll shift your temperature during grid support events"
          destinationPath={settingPaths.eventTemperatures}
        >
          {gridSupportSummary.length > 0 ? (
            <div className="flex flex-col gap-1">
              {gridSupportSummary.map((setting) => (
                <div key={setting.label ?? setting.description}>
                  {setting.label && (
                    <Text
                      variant="body3"
                      className="font-bold text-themed-grey-700"
                    >
                      {setting.label}
                    </Text>
                  )}
                  <span>{setting.description}</span>
                </div>
              ))}
            </div>
          ) : null}
        </ConfigureSettingRow>

        {/* Save Money (both the cost-category flavor and the TOU pre-cool
            fallback) is deliberately NOT shown in post-application setup —
            it's managed from the device Settings tab instead (DEV-6567). */}
      </ConfigureDeviceCard>
    </ConfigureDeviceStepBody>
  )
}
